import McpInstructions from 'components/landing/mcp/McpInstructions'
import { ContextDTO, withUserProps } from 'lib/contextCreation'
import { GetServerSideProps } from 'next'

export const getServerSideProps: GetServerSideProps = async (context) => {
  const result = await withUserProps(
    async () => ({ props: { isResponsive: true, disableSidebar: true } }),
    { forceUnauthorizedMode: true }
  )(context)
  const props = 'props' in result ? result.props as { ctx?: ContextDTO } | undefined : undefined
  if (props?.ctx && !['sellematics', 'sellmonitor', 'mayak'].includes(props.ctx.theme.hostType)) {
    return { notFound: true }
  }
  return result
}

export default function StoreAnalyticsMcpPage() {
  return <McpInstructions kind="inner-analytics" />
}
